import { b2x } from '@b2x/react/src';

import { ServiceSubpageContentType } from '../contentTypes';
import { Page } from './Page';

export interface ContactPageProps {}

export const ContactPage = (props: ContactPageProps) => {
  const page = b2x.usePage<ServiceSubpageContentType>();

  return (
    <Page className="contact-page" hideFooter hideHeader>
      <b2x.Div>
        <b2x.Container>
          <b2x.Row justifyContent={'center'}>
            <b2x.Col size={{ lg: 10, xl: 8, xs: 12 }}>
              <b2x.Div marginBottom={4}>{b2x.formatHtml(page?.content?.body.content)}</b2x.Div>
              <b2x.ContactUs />
            </b2x.Col>
          </b2x.Row>
        </b2x.Container>
      </b2x.Div>
    </Page>
  );
};
